<ng-template #warnDiv let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <i class="fas fa-exclamation-circle fa-2x warnIcon"></i>
        <h4 id="alert-modal-title" class="modal-title warnTittle">{{'common.warn' | translate}}</h4>
        <button type="button" class="close" (click)="hidenWarn()" title="{{'common.close' | translate}}" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      </div>
      <div id="alert-modal-body" class="modal-body">
        <p>{{warn.warnMessage | translate}}</p>
        <ul class="list-group" *ngIf="warn.causes !== undefined && warn.causes !== null && warn.causes.length !== 0">
          <li class="list-group-item" *ngFor="let cause of warn.causes">{{cause | translate}}</li>
        </ul>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary btn-user btn-block" (click)="hidenWarn()">{{'common.close' | translate}}</button>
      </div>
    </div>
</ng-template>
